const STORAGE_KEY = "axiohire_oauth_signup";

export type OauthSignupProvider = "google" | "apple";

export interface OauthSignupSession {
  provider: OauthSignupProvider;
  token: string;
}

export function setSignupSession(session: OauthSignupSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function getSignupSession(): OauthSignupSession | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as OauthSignupSession;
    if ((parsed.provider === "google" || parsed.provider === "apple") && parsed.token) {
      return parsed;
    }
  } catch {
    return null;
  }
  return null;
}

export function clearSignupSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function hasSignupSession(): boolean {
  return Boolean(getSignupSession());
}

/** @deprecated use setSignupSession */
export function setSignupToken(token: string): void {
  setSignupSession({ provider: "google", token });
}

/** @deprecated use getSignupSession */
export function getSignupToken(): string | null {
  const session = getSignupSession();
  return session?.provider === "google" ? session.token : session?.token ?? null;
}

export function clearSignupToken(): void {
  clearSignupSession();
}

export function hasSignupToken(): boolean {
  return hasSignupSession();
}
